import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { QuicklinkModule } from 'ngx-quicklink';
import { SimulationFeedbackService } from '../simulation-started/services';
import { ConfirmationDialogModule } from './dialogs';
import { DeleteFeedbackDialogComponent } from './dialogs/delete-feedback-dialog/delete-feedback-dialog.component';
import { ShareSimulationDialogComponent } from './dialogs/share-simulation-dialog/share-simulation-dialog.component';
import { StopSmulationDialogComponent } from './dialogs/stop-simulation-dialog/stop-simulation-dialog.component';
import { UnsavedChangeDialogModule } from './dialogs/unsaved-change-dialog/unsaved-change-dialog.module';
import { VideoRecordingDialogComponent } from './dialogs/video-recording/video-recording-dialog.component';
import { CustomValidatorDirective } from './directive/custom-validator.directive';
import { DurationComponent } from './duration/duration.component';
import { ExpansionItemOrgComponent } from './expansion-item-org/expansion-item.component';
import { ExpansionItemComponent } from './expansion-item/expansion-item.component';
import { MasterLayoutComponent } from './layouts/master-layout/master-layout.component';
import { SimulationAdminLayoutComponent } from './layouts/simulation-admin-layout/simulation-admin-layout.component';
import { MaterialModule } from './material.module';
import { SideBarLeftComponent, SideBarTopComponent } from './sidebar';
import { SimulationStartedSideBarTopComponent } from './sidebar/simulation-started-siderbar-top/simulation-started-siderbar-top.component';
import { ToastSuccessfullyComponent } from './toast/toast-successfully.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
const SideBarComponent = [
    SideBarLeftComponent,
    SideBarTopComponent,
    SimulationAdminLayoutComponent,
    ToastSuccessfullyComponent,
    VideoRecordingDialogComponent,
    SimulationStartedSideBarTopComponent,
    StopSmulationDialogComponent,
    ShareSimulationDialogComponent,
    DurationComponent,
    DeleteFeedbackDialogComponent,
    CustomValidatorDirective,
    ExpansionItemComponent,
    ExpansionItemOrgComponent,
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        QuicklinkModule,
        MaterialModule,
        FlexLayoutModule,
        ReactiveFormsModule,
        TranslateModule,
        FormsModule,
    ],
    exports: [
        MaterialModule,
        QuicklinkModule,
        ConfirmationDialogModule,
        UnsavedChangeDialogModule,
        FlexLayoutModule,
        StopSmulationDialogComponent,
        SimulationStartedSideBarTopComponent,
        DurationComponent,
        DeleteFeedbackDialogComponent,
        CustomValidatorDirective,
        ExpansionItemComponent,
        ExpansionItemOrgComponent,
    ],
    declarations: [MasterLayoutComponent, ...SideBarComponent],
    providers: [
        SimulationFeedbackService,
        { provide: MAT_DIALOG_DATA, useValue: {} },
        { provide: MatDialogRef, useValue: {} },
    ],
})
export class SharedModule {}
